<template>
    <div class="empty-state-container p-5" :style="{'background-color': color}">
        <p class="m-0">{{text}}</p>
    </div>
</template>

<script>
    export default {
        name: "EmptyState",
        props: ["text", "color"]
    }
</script>

<style scoped>

    .empty-state-container {
        background-color: #F3F2F7;
        display: flex;
        align-items: center;
        justify-content: center;
    }

</style>
